import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Menu as MenuIcon, Settings as SettingsIcon } from '@mui/icons-material';
import StoreSelectorTrigger from './StoreSelectorTrigger';
import StaffNotificationBell from './StaffNotificationBell';
import { BRAND, brandAlpha } from '../../theme/brandTokens';

const headerIconButtonSx = {
  color: BRAND.textMuted,
  '&:hover': { color: BRAND.accentText, bgcolor: brandAlpha('accent', 0.06) },
};

const MobileHeader = ({
  currentStore,
  onDrawerToggle,
  onMenuOpen,
  onStoreClick,
  storeSelectable = true,
  showBranding = true,
}) => {
  return (
    <Box
      component="header"
      sx={{
        display: { xs: 'flex', lg: 'none' },
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: BRAND.surface,
        backgroundImage: 'none',
        borderBottom: `1px solid ${BRAND.line}`,
        boxShadow: 'none',
        minHeight: 64,
        px: 2,
        py: 1,
        alignItems: 'center',
        gap: 1,
        overflow: 'hidden'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: '1 1 auto', overflow: 'hidden' }}>
        <IconButton
          onClick={onDrawerToggle}
          sx={{ ...headerIconButtonSx, flexShrink: 0 }}
        >
          <MenuIcon />
        </IconButton>
        <StoreSelectorTrigger
          currentStore={currentStore}
          onClick={onStoreClick}
          storeSelectable={storeSelectable}
          fallbackLabel="Loading..."
          typographyVariant="h6"
          logoUrl={showBranding ? currentStore?.managementLogoUrl : undefined}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
        <StaffNotificationBell variant="plain" />
        <IconButton
          onClick={onMenuOpen}
          sx={headerIconButtonSx}
        >
          <SettingsIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default MobileHeader;
